{
  "messages": {
    "maximumInSizeOnlyOneImageTextZipOrSpreadsheetAllowedToUploadMultipleDocsZipFirstThenUpload": "Maximum {size} en taille. Seulement {imageLimit}, {typeLimitText}, {typeLimitZip} ou {typeLimitSpreadsheet} autorisé. Pour télécharger plusieurs documents, compressez-les d'abord puis téléversez.",
    "maximumInSizePerFileOnlyImageTextZipSpreadsheetAllowed": "Maximum {size} en taille par fichier. Maximum {count} fichiers. Seulement {image}, {text}, {zip} ou {spreadsheet} autorisé.",
    "oneImage": "UNE image",
    "sizeInMegabytes": "{size} Mo",
    "uploadDocument": "Téléverser un document",
    "uploadDocuments": "Téléverser des documents"
  }
}
